import { ModuleWithProviders, NgModule } from '@angular/core'

import { AnalyticsEventDirective } from './analytics-event.directive'
import { ANALYTICS_TRACKER } from './analytics-tracker.token'
import { AnalyticsConfig, AnalyticsService } from './analytics.service'

@NgModule({
  imports: [AnalyticsEventDirective],
  exports: [AnalyticsEventDirective],
  providers: [AnalyticsService, { provide: ANALYTICS_TRACKER, useExisting: AnalyticsService }],
})
export class AnalyticsModule {
  static forRoot(analyticsConfig: AnalyticsConfig): ModuleWithProviders<AnalyticsModule> {
    return {
      ngModule: AnalyticsModule,
      providers: [
        AnalyticsService,
        { provide: ANALYTICS_TRACKER, useExisting: AnalyticsService },
        { provide: 'ANALYTICS_CONFIG', useValue: analyticsConfig },
      ],
    }
  }
}
